import { render, staticRenderFns } from "./PersonPhoto.vue?vue&type=template&id=021b0310&"
import script from "./PersonPhoto.vue?vue&type=script&lang=js&"
export * from "./PersonPhoto.vue?vue&type=script&lang=js&"
import style0 from "./PersonPhoto.vue?vue&type=style&index=0&id=021b0310&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports